import React, {Component} from 'react';
import {Button, Col, Container, Row} from "reactstrap";
import {connect} from "react-redux";
import * as _ from 'lodash';
import "./index.css"
import assets from "../../../../util/assets";
import * as actions from "../../../../actions";
import {PublishListItem} from "../../../../components/clipstore/broadcaster/library/publish-list-item";
import api from "../../../../util/clipstore/broadcaster/library";
import {VideoPlayerModal} from "../../../../components/modal/clipstore/broadcaster/VideoPlayerModal";
import {SetPricingModal} from "../../../../components/modal/clipstore/broadcaster/SetPricingModal";
import {SelectGalleryModal} from "../../../../components/modal/clipstore/broadcaster/SelectGalleryModal";
import {EditVideoModal} from "../../../../components/modal/clipstore/broadcaster/EditVideoModal";
import {GalleryModal} from "../../../../components/modal/clipstore/broadcaster/GalleryModal";
import Loading from "react-loading-animation";
import {vuepayAlert} from "../../../../util/utility";

class PublishVideoContent extends Component {

    constructor() {
        super();

        this.state = {
            width: 96,
            height: 54,
            searchValue: '',
            sortBy: 'new',
            videoIdArray: [],
            pictureIdArray: [],
            contentType: "video",
            isSetPricingModalOpen: false,
            isSelectGalleryModalOpen: false,
            isCreateGalleryModalOpen: false,
            isEditModalOpen: false,
            contentForPricing: {},
            publishContent: [],

            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            content: {},
            contentList: [],

            selectedGallery: null,
            selectedContentIndex: null,
        }


        this.getPublishIds = this.getPublishIds.bind(this);
        this.getPublishedContent = this.getPublishedContent.bind(this);
        this.getMyLibrary = this.getMyLibrary.bind(this);
        this.thumbnailClicked = this.thumbnailClicked.bind(this);
        this.setPricing = this.setPricing.bind(this);
        this.addToGallery = this.addToGallery.bind(this);
        this.editVideo = this.editVideo.bind(this);
        this.deleteVideo = this.deleteVideo.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onPublish = this.onPublish.bind(this);
        this.updatePublishContent = this.updatePublishContent.bind(this)
    }

    loadNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;

        this.setState({
            currentPage
        }, () => {
            api.getMyLibraryAPI(this.props, {
                width: this.state.width,
                height: this.state.height,
                searchValue: this.state.searchValue,
                sortBy: this.state.sortBy,
                page: this.state.currentPage,
            });
        })
    }

    componentDidMount() {

        // if (this.props.get_my_library.payload === null) {
        //     this.getMyLibrary()
        // } else {
        //     this.getPublishedContent(this.props.get_my_library.payload);
        // }

        this.getMyLibrary()
        this.getMyGallery();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // if (nextProps.get_my_library && nextProps.get_my_library.payload !== this.props.get_my_library.payload) {
        //     this.getPublishedContent(nextProps.get_my_library.payload);
        // }

        //this will be called for every pagination we perform
        if (nextProps.get_my_library && nextProps.get_my_library.payload !== this.props.get_my_library.payload) {

            if (nextProps.get_my_library.payload &&
                nextProps.get_my_library.payload.hasOwnProperty("data")) {

                let data = nextProps.get_my_library.payload;
                let contentList = data.data;

                if (this.state.currentPage !== 1) {
                    if (contentList.length > 0) {
                        contentList = this.state.contentList.concat(contentList)
                    } else {
                        contentList = this.state.contentList;
                    }
                }

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.length,
                    totalItems: parseInt(data.total),
                    contentList,
                    reset: false
                }, () => {

                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    } else {
                        this.getPublishedContent(this.state.contentList);
                    }
                })
            }
        }

        //handle the API response for publishing the videos
        api.handleAPIResponse(nextProps, "publish_videos", () => {
            //reset the payload value as we have captured the event
            this.props.resetPublishVideos();
        }, () => {
            this.props.history.push("/broadcaster/my-library")
        }, () => {
            //nothing to handle
        })

        //handle the API response for deleting the video
        api.handleAPIResponse(nextProps, "delete_videos", () => {
            //reset the payload value as we have captured the event
            this.props.resetDeleteVideos();
        }, () => {
            this.props.history.push("/broadcaster/my-library")
        }, () => {
            //nothing to handle
        })

        //handle the API response for add the video to gallery
        api.handleAPIResponse(nextProps, "add_video_to_gallery", () => {
            //reset the payload value as we have captured the event
            this.props.resetAddVideoToGallery();
        }, () => {
            this.updatePublishContent();
            //this.getMyLibrary();
            //this.getMyGallery();
        }, () => {
            //nothing to handle
        })

    }

    updatePublishContent() {
        if (this.state.selectedContentIndex !== -1) {
            let publishContent = _.cloneDeep(this.state.publishContent);
            const content = publishContent[this.state.selectedContentIndex];
            publishContent[this.state.selectedContentIndex] = {
                ...content,
                gallery: this.state.selectedGallery
            }

            const gallery = this.state.selectedGallery;
            if (gallery && gallery.hasOwnProperty("published") && gallery.published === "yes") {
                vuepayAlert("success","Your content is published",()=>{
                    this.onCancel();
                })
            }
            this.setState({
                publishContent,
                selectedGallery: null
            })
        }
        this.setSelectGalleryModal(false)
    }

    getPublishIds() {
        const url_string = window.location.href
        const url = new URL(url_string);
        return url.searchParams.get("ids");
    }

    getPublishedContent(payload) {
        const ids = this.getPublishIds();
        let publishContent = _.filter(payload, function (content) {
            return ids.indexOf(content.id) !== -1;
        });

        this.setState({
            publishContent
        })
    }

    getMyLibrary() {
        api.getMyLibraryAPI(this.props, {
            width: this.state.width,
            height: this.state.height,
            searchValue: this.state.searchValue,
            sortBy: this.state.sortBy,
            page: this.state.currentPage,
        });
    }

    getMyGallery() {
        api.getMyGallery(this.props, {
            width: this.state.width,
            height: this.state.height,
        });
    }

    thumbnailClicked(id) {

        const result = this.state.contentList.filter(content => content.id === id);

        if (Array.isArray(result) && result.length > 0) {
            this.props.showBroadcasterVideoPlayerModal({
                video: result[0],
                action: {
                    text: "CLOSE",
                    click: () => {

                    }
                }
            });
        }
    }

    setPricing(id) {
        const result = this.state.contentList.filter(content => content.id === id);

        if (Array.isArray(result) && result.length > 0) {
            this.setState({
                contentForPricing: result[0],
                isSetPricingModalOpen: true
            }, () => {
                this.props.setAddEditPricing(result[0])
            });
        }
    }

    editVideo(id) {
        const result = this.state.contentList.filter(content => content.id === id);

        if (Array.isArray(result) && result.length > 0) {
            this.setState({
                contentForPricing: result[0],
                isEditModalOpen: true
            }, () => {
                this.props.setAddEditPricing(result[0])
            });
        }
    }

    setSelectGalleryModal = (isSelectGalleryModalOpen) => {
        this.setState({
            isSelectGalleryModalOpen
        })
    }

    setCreateGalleryModal = (isCreateGalleryModalOpen) => {
        this.setState({
            isCreateGalleryModalOpen
        })
    }

    setEditVideoModal = (isEditModalOpen) => {
        this.setState({
            isEditModalOpen
        })
    }

    addToGallery(id, type) {

        if (type === "picture") {
            this.setState({
                videoIdArray: [],
                contentType: type,
                pictureIdArray: [id]
            });
        } else {
            this.setState({
                videoIdArray: [id],
                contentType: type,
                pictureIdArray: []
            });
        }


        const index = _.findIndex(this.state.publishContent, function (o) {
            return o.id === id;
        });
        this.setState({
            selectedContentIndex: index
        })
        this.setSelectGalleryModal(true);
    }

    deleteVideo(id) {
        api.onDelete(this.props, id)
    }

    onCancel() {
        this.props.history.push("/broadcaster/my-library")
    }

    onPublish() {
        let ids = this.getPublishIds(), videoIdsArray = [], pictureIdsArray = [];
        ids = ids.split(",");

        ids.map((id) => {
            this.state.contentList.map((content) => {
                if (content.id === id) {
                    if (content.type === "picture") {
                        pictureIdsArray.push(id);
                    } else {
                        videoIdsArray.push(id);
                    }
                }
            });
        })

        api.publishVideosAPI(this.props, {
            ids: videoIdsArray,
            picture_ids: pictureIdsArray
        })
    }

    render() {
        return (
            <main role="main" className="">
                <div className="broadcast-container-parent row">
                    <div className="broadcast-container other-middle-container">
                        <Container className="my-library-home-container no-padding">
                            <Row className="display-flex-vertical-center no-margin border-bottom"
                                 style={{padding: 16}}>
                                <Col sm="12" className="my-library-title no-padding text-align-left ">Publish
                                    Content</Col>
                            </Row>

                            <GalleryModal
                                isOpen={this.state.isCreateGalleryModalOpen}
                                history={this.props.history}
                                toggle={(key) => {
                                    this.setCreateGalleryModal(false)

                                    if(key === "refresh"){
                                        this.getMyLibrary();
                                        this.getMyGallery();
                                    }
                                }}
                                title={"Create a Gallery"}/>

                            {
                                this.state.isEditModalOpen &&
                                <EditVideoModal
                                    isOpen={this.state.isEditModalOpen}
                                    toggle={(key) => {
                                        this.setEditVideoModal(false);

                                        if (key === "refresh") {
                                            this.getMyLibrary();
                                            this.getMyGallery();
                                        }
                                    }}
                                    history={this.props.history}
                                />
                            }


                            <SelectGalleryModal
                                isOpen={this.state.isSelectGalleryModalOpen}
                                toggle={() => {
                                    this.setSelectGalleryModal(false);
                                }}
                                contentType={this.state.contentType}
                                resetSetAddEditPricing={this.props.resetSetAddEditPricing}
                                setCreateGalleryModal={this.setCreateGalleryModal}
                                gallery={this.props.get_my_gallery.payload}
                                add_video_to_gallery={this.props.add_video_to_gallery}
                                action={(gallery_id, gallery) => {
                                    let idArray = this.state.videoIdArray;
                                    if (this.state.contentType === "picture") {
                                        idArray = this.state.pictureIdArray;
                                    }
                                    this.setState({
                                        selectedGallery: gallery
                                    }, () => {
                                        api.addContentToGalleryAPI(this.props, idArray, gallery_id, this.state.contentType)
                                    })
                                }}
                            />

                            <SetPricingModal
                                history={this.props.history}
                                content={this.state.contentForPricing}
                                isOpen={this.state.isSetPricingModalOpen}
                                toggle={(key) => {

                                    this.setState({
                                        isSetPricingModalOpen: false
                                    })

                                    if (key === "refresh") {
                                        this.getMyLibrary();
                                        this.getMyGallery();
                                    }
                                }}
                                gallery={this.props.get_my_gallery.payload}
                            />

                            {
                                this.props.flag.hasOwnProperty("showBroadcasterVideoPlayerModal") &&
                                this.props.flag.hasOwnProperty("broadcasterVideoPlayerModalPayload") &&
                                this.props.flag.broadcasterVideoPlayerModalPayload.hasOwnProperty("video") &&
                                this.props.flag.broadcasterVideoPlayerModalPayload.video !== null &&
                                <VideoPlayerModal
                                    isOpen={this.props.flag.showBroadcasterVideoPlayerModal}
                                    video={this.props.flag.broadcasterVideoPlayerModalPayload.video}
                                    action={this.props.flag.broadcasterVideoPlayerModalPayload.action}
                                    hideVideoPlayerModal={this.props.hideBroadcasterVideoPlayerModal}
                                />
                            }

                            <div className="wrapper">

                                <div className="publish-content-container">
                                    {
                                        this.props.get_my_library.isFetching ?
                                            <Loading/>
                                            :
                                            this.state.publishContent.map((content, index) => {

                                                return (
                                                    <PublishListItem
                                                        openGallery={(id) => {
                                                            this.props.history.push(`/broadcaster/my-library/gallery?id=${id}`)
                                                        }}
                                                        isPricing={false}
                                                        key={content.id}
                                                        index={index}
                                                        content={content}
                                                        gallery={this.props.get_my_gallery.payload}

                                                        thumbnailClicked={this.thumbnailClicked}
                                                        setCreateGalleryModal={this.setCreateGalleryModal}
                                                        setPricing={this.setPricing}
                                                        editVideo={this.editVideo}
                                                        addToGallery={this.addToGallery}
                                                        deleteVideo={this.deleteVideo}

                                                        duplicate_videos={this.props.duplicate_videos}
                                                        delete_videos={this.props.delete_videos}
                                                        publish_videos={this.props.publish_videos}
                                                    />
                                            )
                                        })
                                    }
                                </div>
                                <Row className="display-flex-vertical-center no-margin">
                                    <Col md="6" className="my-library-title no-padding text-align-left"/>
                                    <Col md="6" className="no-padding  text-align-right">
                                        <Button color="outline-secondary" onClick={this.onCancel}>
                                            CANCEL
                                        </Button>

                                        <Button color="primary" onClick={this.onPublish}>
                                            {
                                                this.props.publish_videos.isFetching
                                                    ?
                                                    <img
                                                        src={assets.loading_white}
                                                        alt={"Loading"}
                                                        width={26}
                                                        height={26}
                                                    />
                                                    :
                                                    "PUBLISH"
                                            }

                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Container>

                    </div>
                </div>
            </main>
        )
    }
}


function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        get_my_library: state.clipstore_broadcaster_get_my_library,
        duplicate_videos: state.clipstore_broadcaster_duplicate_videos,
        delete_videos: state.clipstore_broadcaster_delete_videos,
        publish_videos: state.clipstore_broadcaster_publish_videos,
        get_my_gallery: state.clipstore_broadcaster_get_my_gallery,
        add_video_to_gallery: state.clipstore_broadcaster_reducer_add_video_to_gallery,
    };
}

export default connect(mapStateToProps, actions)(PublishVideoContent);